export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-drag/~/d3-selection/src/selection/empty.js
// module id = Jm4E
// module chunks = 0